import { NgModule } from '@angular/core';
import { OrderFormLibComponent } from './order-form-lib.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { CrmAlertComponent } from './components/crm-alert/crm-alert.component';
import { AuthProvider } from './providers/auth.provider';
import { LibOrderProvider } from './providers/order.provider';

@NgModule({
  declarations: [OrderFormLibComponent, OrderDetailComponent, CrmAlertComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  exports: [OrderFormLibComponent, OrderDetailComponent, CrmAlertComponent],
  providers: [AuthProvider, LibOrderProvider]
})
export class OrderFormLibModule { }
